import Vue from 'vue';
import moment from '@/plugins/moment';
import VueMoment from 'vue-moment';
import 'moment/locale/ru';

moment.locale('ru');

Vue.use(VueMoment, { moment });